import React, { useEffect, useState } from 'react';
import { TAG_TYPES, USER_ROLES, isUserAuthorized, showError, showSuccess } from 'utils';
import { Loading } from 'components/loading/Loading';
import ActionButton from 'components/ActionButton';
import DataTable from 'components/DataTable';
import { tableStyles } from 'css/tableStyles';
import styles from './index.module.scss';
import DeleteActionForTable from 'components/DeleteActionForTableData';
import { fetchInventoryItemTags, removeInventoryItemTag } from 'services';
import AssignTagModal from 'components/AssignTagModal';

const InventoryItemTags =(props: {itemId: string; userRoles?: any })=>{
  const isUserAuthorizedToEdit = isUserAuthorized(props.userRoles, [USER_ROLES.PACKER, USER_ROLES.SUPERVISOR, USER_ROLES.MANAGER, USER_ROLES.ADMIN]);

  const [loading, setLoading] = useState<boolean>(false);
  const [itemTags, setItemTags] = useState<Record<string, any>[]>([]);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const { itemId } = props;

  const columns =[
    {
      name: 'Id',
      selector: 'objectId',
    },
    {
      name: 'Name',
      selector: 'value',
    },
    {
      name: 'English Name',
      selector: 'enValue',
    },
    {
      name: 'Slug',
      selector: 'slug',
    },
    {
      name: 'English Slug',
      selector: 'enSlug',
    },
    {
      name: 'Action',
      selector: '',
      omit: !isUserAuthorizedToEdit,
      // eslint-disable-next-line react/display-name
      cell: (row: Record<string, any>) => (
        <div className={'ml-3'}>
          <DeleteActionForTable
            onClick={() => deletAvailableTags(row.objectId)}
          />
        </div>
      ),
    },
  ];

  const deletAvailableTags = async(tagId)=>{
    try{
      await removeInventoryItemTag(itemId, tagId);
      showSuccess('Tag is removed Successfully');
      fetchItemTags();
    }catch(e){
      showError(e);
    }
  };

  const fetchItemTags = async () => {
    setLoading(true);
    try {
      const response = await fetchInventoryItemTags(itemId);
      setItemTags(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItemTags();
  }, []);

  return (
    <>
      {loading ? <Loading /> : null}
      {openModal && 
        <AssignTagModal
          toggleModal={()=>setOpenModal(!openModal)} 
          onSuccess={()=>fetchItemTags()}
          itemId={itemId}
          assignedTags={itemTags.map(tag=>tag.objectId)}
          tagType={TAG_TYPES.INVENTORY_ITEM}
        />
      }
      <div className={styles['related-items-container']}>
        <div className={styles['section-header']}>
          <div className={styles['section-heading']}>Assigned Tags</div>
          {isUserAuthorizedToEdit && <ActionButton
            text={<>Assign Tags <span className={'ml-3'}>+</span></>}
            active={true}
            isLoading={false}
            onClick={() => setOpenModal(true)}
          />}
        </div>
        <DataTable
          columns={columns}
          noHeader={true}
          data={itemTags}
          highlightOnHover={true}
          customStyles={tableStyles}
          pagination={false}
        />
      </div>
    </>
  );
};

export default InventoryItemTags;